import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateCopyAssetsOperationMutationVariables = Types.Exact<{
  input: Types.CreateCopyAssetsOperationInput;
}>;


export type CreateCopyAssetsOperationMutation = { __typename?: 'Mutation', createCopyAssetsOperation?: { __typename?: 'CreateCopyAssetsOperationPayload', assetOperation?: { __typename?: 'CopyAssetsOperation', id?: string | null } | { __typename?: 'DeleteAssetsOperation', id?: string | null } | { __typename?: 'HardDeleteAssetsOperation', id?: string | null } | { __typename?: 'MoveAssetsOperation', id?: string | null } | { __typename?: 'UpdateAssetFieldValuesOperation', id?: string | null } | null } | null };


export const CreateCopyAssetsOperation = /*#__PURE__*/ gql`
    mutation CreateCopyAssetsOperation($input: CreateCopyAssetsOperationInput!) {
  createCopyAssetsOperation(input: $input) {
    assetOperation {
      id
    }
  }
}
    ` as unknown as DocumentNode<CreateCopyAssetsOperationMutation, CreateCopyAssetsOperationMutationVariables>;

          

          export const useCreateCopyAssetsOperationMutation = (options?:MutationHookOptions<CreateCopyAssetsOperationMutation, CreateCopyAssetsOperationMutationVariables>) => useMutation(CreateCopyAssetsOperation, options);
          

          export type CreateCopyAssetsOperationMutationOptions = MutationHookOptions<CreateCopyAssetsOperationMutation, CreateCopyAssetsOperationMutationVariables>;

          

          export type CreateCopyAssetsOperationMutationResult = ReturnType<typeof useCreateCopyAssetsOperationMutation>[1];

          
